import { DecimalPipe } from '@angular/common';
import { Component, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Util } from '@pacifico/utils/util';
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-empty-function */
@Component({
	selector: 'app-input-numeric',
	templateUrl: './input-numeric.component.html',
	styleUrls: ['./input-numeric.component.scss'],
	providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputNumericComponent), multi: true }]
})
export class InputNumericComponent implements ControlValueAccessor, OnChanges {
	constructor(private _decimalPipe: DecimalPipe) {}

	@Input() value: number | undefined;

	@Input() minDecimals = 2;
	@Input() maxDecimals = 2;
	@Input() disabled = false;
	@Input() required = false;
	@Input() placeholder = '0.00';

	valueText = '';

	private _onChange = (_value: number) => {};
	private _onTouched = () => {};

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.value) {
			this.valueText = String(this.value);
		}
	}

	changeEvent(value: string): void {
		if (this.valueText === value) {
			this._asynValue(value);
			return;
		}

		this.valueText = this._transformValue(value);
		this._onTouched();
		this._onChange(Number(Util.replaceCommaNumber(this.valueText)));
	}

	private _asynValue(value: string): void {
		this.valueText = '';
		setTimeout(() => {
			this.valueText = this._transformValue(value);
			this._onTouched();
			this._onChange(Number(Util.replaceCommaNumber(this.valueText)));
		}, 0);
	}

	private _transformValue(value: string): string {
		const valueTransform = this._decimalPipe.transform(
			Util.replaceCommaNumber(value),
			`1.${this.minDecimals}-${this.maxDecimals}`
		);

		return valueTransform!;
	}

	writeValue(value: any): void {
		if (value) {
			this.value = Number(value);
		}
	}

	registerOnChange(fn: any): void {
		this._onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this._onTouched = fn;
	}

	setDisabledState?(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	// set value(val: number) {
	// 	this.valueText = String(val);
	// 	this._onChange(val);
	// 	this._onTouched();
	// }
}
